import styled from 'styled-components';
import { fonts } from 'ui/theme';
import { isDefined } from 'utils/tsHelpers';
import { useContentWatch } from '../../hooks/form';
import { ContentMetadataProvider } from './contexts/ContentMetadata';
import { Placeholder } from './placeholder';
import { SelectedContent } from './selectedContent';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing.values.x3} 1fr ${({ theme }) =>
    theme.spacing.values.double};
  grid-template-rows: 1fr;
  grid-template-areas: 'left center right';
  gap: 10px;
  align-items: center;
  padding: 20px;
  background-color: #fafafa;
  border-radius: 6px;
  font-family: ${fonts.sansSerif};
`;

export const ContentPicker = () => {
  const content = useContentWatch();

  return (
    <ContentMetadataProvider>
      <Wrapper>{isDefined(content) ? <SelectedContent /> : <Placeholder />}</Wrapper>
    </ContentMetadataProvider>
  );
};
